const MESSAGING_DRAFT_PREFIX = 'messagingDraft:';

const draftStorageKey = (userId: string, draftKey: string) =>
  `${MESSAGING_DRAFT_PREFIX}${userId}:${draftKey}`;

// Storage throws in browsers that block it, and a draft is never worth failing a keystroke over.
const withSessionStorage = <T>(use: (storage: Storage) => T, fallback: T) => {
  try {
    return use(sessionStorage);
  } catch {
    return fallback;
  }
};

export const readMessagingDraft = (userId: string, draftKey: string) =>
  withSessionStorage(
    (storage) => storage.getItem(draftStorageKey(userId, draftKey)),
    null,
  );

export const writeMessagingDraft = (userId: string, draftKey: string, content: string) =>
  withSessionStorage((storage) => {
    const key = draftStorageKey(userId, draftKey);

    if (content.length > 0) {
      storage.setItem(key, content);
    } else {
      storage.removeItem(key);
    }
  }, undefined);

export const clearMessagingDrafts = () =>
  withSessionStorage((storage) => {
    Array.from({ length: storage.length }, (_, index) => storage.key(index))
      .filter((key): key is string => Boolean(key?.startsWith(MESSAGING_DRAFT_PREFIX)))
      .forEach((key) => storage.removeItem(key));
  }, undefined);
